import React from "react";
import useScrollReveal from "@/hooks/useScrollReveal";

import CategoryHero from "@/components/site/CategoryHero";
import CategoryTabs from "@/components/site/CategoryTabs";
import ProcessMain from "@/components/site/main/ProcessMain";
import ProjectCatalogue from "@/components/site/ProjectCatalogue";
import WhatWeOfferMain from "@/components/site/main/WhatWeOfferMain";
import TrustedPartners from "@/components/site/TrustedPartners";
import LaunchOfferMain from "@/components/site/main/LaunchOfferMain";
import FAQ, { MAIN_FAQS } from "@/components/site/FAQ";
import PreFooterCTAMain from "@/components/site/main/PreFooterCTAMain";
import SEO from "@/components/site/SEO";
import { pageSeo, localBusinessJsonLd, serviceJsonLd, faqJsonLd } from "@/lib/seo-config";

export default function OfficeFitOutDubai() {
    useScrollReveal();
    return (
        <main data-testid="page-office-fit-out">
            <SEO
                {...pageSeo.office}
                jsonLd={[
                    localBusinessJsonLd,
                    serviceJsonLd({
                        type: "Office Fit-Out",
                        name: "Office Fit-Out Dubai",
                        description: pageSeo.office.description,
                        path: pageSeo.office.path,
                    }),
                    faqJsonLd(MAIN_FAQS),
                ]}
            />
            <CategoryHero
                eyebrow="OFFICE FIT-OUT • DUBAI"
                h1="Office Fit-Out Dubai — Delivered in 45 Days"
                sub="From workstations and partitions to reception areas, meeting rooms, branding and handover — 45DaySpaces delivers professional office fit-outs across Dubai with transparent AED pricing."
                image="https://customer-assets.emergentagent.com/job_dream-design-deliver/artifacts/83t8nwft_Fitout.jpg"
                imageAlt="Modern Dubai office fit-out with glass partitions, workstations and branded reception area"
                estimatorType="office"
            />
            <CategoryTabs initialTab="office" />
            <ProcessMain />
            <ProjectCatalogue />
            <WhatWeOfferMain />
            <TrustedPartners />
            <LaunchOfferMain />
            <FAQ items={MAIN_FAQS} />
            <PreFooterCTAMain />
        </main>
    );
}
